import { Injectable, signal } from '@angular/core';

/** Keep an explicit recovery command on screen until its outcome is known. */
@Injectable({ providedIn: 'root' })
export class PlatformOperationsStateService {
  private readonly busy = signal(false);
  readonly isOperationInProgress = this.busy.asReadonly();
  setOperationInProgress(value: boolean): void {
    this.busy.set(value);
  }
}
